import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safehtml/safehtml.pipe';

@NgModule({
	declarations: [SafeHtmlPipe],
	imports: [],
	exports: [SafeHtmlPipe]
})
export class SafeHtmlModule {}
